import request from '@/utils/request'

let ParkApi = {

  /*政府园区列表*/
  list(data) {
    return request._post('/shop/plus.park.Index/index', data);
},
shelves(data) {
    return request._post('/shop/plus.park.Index/shelves', data);
},
/*添加政府园区*/
add(data) {
    return request._post('/shop/plus.park.Index/add', data);
},
/*修改政府园区*/
edit(data) {
    return request._post('/shop/plus.park.Index/edit', data);
},
/*删除政府园区*/
del(data) {
    return request._post('/shop/plus.park.Index/del', data);
},
/*政府园区详情*/
detail(data) {
  return request._post('/shop/plus.park.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.park.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.park.Setting/getSetting', data, errorback);
    },
}
export default ParkApi;



// WEBPACK FOOTER //
// ./src/api/park.js